<template>
  <div>
    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <header class="hc-hero-secondary hc-section header_bg hc_container_mobile_np">
          <div class="hc-hero-secondary__body bg-offwhite-100">
            <AnimationTextBg divClass="hc-hero-secondary"></AnimationTextBg>
            <div class="hc-hero-secondary__left">
              <div class="hc-hero-secondary__breadcrumbs">
                <span>
                  <router-link to="/home">{{ $t('router.home') }}</router-link>
                </span>
                <span> {{ $t('router.benefits') }} </span>
              </div>
              <div class="has-eyebrow-font-size"> {{ $t('router.benefits') }}</div>

              <h1 class="wp-block-heading hc-hero-secondary__title has-t-disp-2-font-size">
                {{ $t('benefits.bigTitle1') }}<br v-if="device === 'pc'" /><span v-else>{{ $t('benefits.bigTitleDou')
                  }}</span>{{ $t('benefits.bigTitle2') }}
              </h1>

              <p class="hc-hero-secondary__description has-md-font-size">
                {{ $t('benefits.titleDesc1') }}
                <br /> <br />
                {{ $t('benefits.titleDesc2') }}
              </p>
            </div>
            <div class="hc-hero-secondary__right header-img">
              <figure class="wp-block-image aligncenter size-full hc-hero-secondary__right-img">
                <img :src="img_chinese_concierge_171f5c" alt="" class="wp-image-24937" />
                <figcaption class="wp-element-caption">
                  {{ $t('benefits.titleLocation') }}
                </figcaption>
              </figure>
            </div>
          </div>
        </header>
      </section>
    </section>
    <section class="hc-section bg-darkblue padding-bottom">
      <SectionTextureBg v-if="device === 'pc'" position="bottom"></SectionTextureBg>
      <div class="hc-cntr bg-offwhite-100">
        <section class="hc-tabbed-card">
          <div class="hc-tabbed-card__intro bg-offwhite-100">
            <h2 class="wp-block-heading hc-tabbed-card__intro-title has-t-disp-3-font-size">
              {{ $t('benefits.welfareTitle1') }} <br />
              {{ $t('benefits.welfareTitle2') }}
            </h2>

            <p class="hc-tabbed-card__intro-content has-md-font-size">
              {{ $t('benefits.welfareDesc') }}
            </p>
          </div>
          <div class="hc-tabbed-card__tabs bg-offwhite-100">
            <div class="hc-tabbed-card__panels">
              <div class="hc-tabbed-card__panel js-tab-panel is-open">
                <div class="hc-tabbed-card__panel-body js-tab-body">
                  <div :class="`hc-tabbed-card__row ${cardRowItem.showFlag && 'active'}`"
                    v-for="cardRowItem in cardTabs">
                    <h3 class="hc-tabbed-card__row-title t-disp-5" @click="changeTabMb(cardRowItem.flag)">
                      <span>
                        {{ cardRowItem.title }}
                      </span>
                      <div class="section-line">
                      </div>
                    </h3>
                    <div class="hc-tabbed-card__cards">
                      <div class="hc-tabbed-card__card" v-for="card in cardRowItem.cardList">
                        <figure class="wp-block-image size-full hc-tabbed-card__card-img">
                          <img :src="card.imgUrl" alt="" class="wp-image-19381" />
                        </figure>

                        <h5 class="wp-block-heading hc-tabbed-card__card-title has-t-title-4-font-size">
                          {{ card.title }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    </section>
    <section class="hc-section bg-offwhite-100">
      <div class="hc-cntr bg-white track-img">
        <section class="hc-img-gal js-img-gal is-initialized">
          <div class="hc-img-gal__info">
            <h2 class="wp-block-heading hc-img-gal__title has-t-disp-3-font-size track-title-mb">
              {{ $t('benefits.hotelGoHilton') }}
            </h2>

            <p class="has-md-font-size">
              {{ $t('benefits.hotelGoHiltonDesc1') }}
            </p>

            <p class="has-md-font-size">
              {{ $t('benefits.hotelGoHiltonDesc2') }}
            </p>

            <p class="has-md-font-size">
              <a class="under-line" href="https://www.hilton.com.cn">{{ $t('benefits.hotelGoHiltonDesc3') }}</a>
            </p>
          </div>
          <div class="hc-img-gal__controls mb-hidden">
          </div>
          <div class="hc-img-gal__slider">
            <div>
              <figure class="hc-img-gal__stage js-img-gal-stage">
                <img width="1024" height="1024" :src="imageTrackList[activeTrack].bigImg"
                  class="attachment-full size-full" alt="" />
              </figure>
              <div class="hc-img-gal__controls" v-if="device==='pc'">
                <div class="hc-img-gal__pos t-title-4">
                  <strong class="js-img-gal-pos">0{{ activeTrack + 1 }}</strong>
                  &nbsp;/&nbsp; 0{{ imageTrackList.length }}
                </div>
                <div class="hc-img-gal__nav">
                  <button type="button" @click="changeActiveTrack('reduce')">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 44">
                      <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M18.25 16.75 22 13m0 0 3.75 3.75M22 13v18"></path>
                    </svg>
                  </button>
                  <button type="button" @click="changeActiveTrack('add')">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 44">
                      <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M18.25 27.25 22 31m0 0 3.75-3.75M22 31V13"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="hc-img-gal__controls hc-img-gal__controls_mobile" v-else>
                <div @click="changeActiveTrack('reduce')">
                  <img class="trans-180" :src="right_arrow" alt="">
                </div>
                <div class="hc-img-gal__pos t-title-4">
                  <strong class="js-img-gal-pos">0{{ activeTrack + 1 }}</strong>
                  &nbsp;/&nbsp; 0{{ imageTrackList.length }}
                </div>
                <div @click="changeActiveTrack('add')">
                  <img :src="right_arrow" alt="">
                </div>
              </div>

            </div>

            <div class="hc-img-gal__track js-img-gal-track">
              <ul>
                <li v-for="(imageItem, index) in imageTrackList" :key="index">
                  <button @click="activeTrack = index" type="button" :class="`hc-img-gal__btn js-img-gal-btn ${activeTrack === index && 'is-active'
                    }`" :data-img="imageItem.bigImg">
                    <img width="158" height="158" :src="imageItem.img"
                      class="attachment-gallery-thumb size-gallery-thumb" alt="" />
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </section>
    <section class="hc-geo is-loaded">
      <section class="hc-geo__region is-active">
        <section :class="`hc-hero-secondary hc-section ${device === 'pc' ? 'apply_bg' : 'apply_bg_mb'}`">
          <div class="apply-content">
            <div class="apply-content__left">
              <img :src="apply_font" width="90%" alt="">
            </div>
            <div class="apply-content__right">
              <div class="apply-content__right-in">
                <h2 class="has-t-disp-3-font-size">{{ $t('benefits.action') }}</h2>
                <CommonButton buttonType="primary-action" :clickHandle="goSearchJob" :buttonText="$t('searchjobs')" />
              </div>

            </div>
          </div>
        </section>
      </section>
    </section>
    <FooterScrolldoor />
  </div>
</template>

<script setup>
import img_chinese_concierge_171f5c from "@/assets/image/benefits/chinese-concierge_171f5c.jpg";
import track_img1 from '@/assets/image/benefits/track_img1.jpg'
import track_img2 from '@/assets/image/benefits/track_img2.jpg'
import track_img3 from '@/assets/image/benefits/track_img3.jpg'
import track_img4 from '@/assets/image/benefits/track_img4.jpg'
import track_img5 from '@/assets/image/benefits/track_img5.jpg'
import track_img6 from '@/assets/image/benefits/track_img6.jpg'
import track_img7 from '@/assets/image/benefits/track_img7.jpg'


import insurance from '@/assets/image/benefits/insurance.svg'
import annualPhysical from '@/assets/image/benefits/annualPhysical.svg'
import GOHilton from '@/assets/image/benefits/GOHilton.svg'
import TME_giftShop from '@/assets/image/benefits/TME-giftShop.svg'
import otherDiscounts from '@/assets/image/benefits/otherDiscounts.svg'
import healthTips from '@/assets/image/benefits/healthTips.svg'
import mentalCare from '@/assets/image/benefits/mentalCare.svg'
import sf from '@/assets/image/benefits/SF.svg'
import womenWellbeing from '@/assets/image/benefits/womenWellbeing.svg'
import mentalHealth from '@/assets/image/benefits/mentalHealth.svg'
import caregivingConcierge from '@/assets/image/benefits/caregivingConcierge.svg'
import careForAll from '@/assets/image/benefits/careForAll.svg'
import apply_font from '@/assets/image/benefits/apply-font.png'
import right_arrow from '@/assets/image/benefits/right-arrow.svg'

import AnimationTextBg from "@/components/AnimationTextBg.vue";
import SectionTextureBg from "@/components//SectionTextureBg.vue";
import FooterScrolldoor from '@/components/FooterScrolldoor.vue'
import CommonButton from "@/components/CommonButton.vue";
import { useI18n } from "vue-i18n";
import { ref, computed, inject } from "vue";
import { useRouter } from "vue-router";
const device = inject("device");
const router = useRouter();
const { t, locale } = useI18n();

const showPhysicalWellness = ref(false)
const showHiltonPrivilege = ref(false)
const showWomenHealth = ref(false)
const showWmentalWellbeing = ref(false)
const leftActive = ref(false)
const cardTabs = computed(() => {
  return [
    {
      title: t('benefits.physicalWellness'),
      showFlag: showPhysicalWellness.value,
      flag: 'showPhysicalWellness',
      cardList: [
        {
          imgUrl: insurance,
          title: t('benefits.insurance'),
        },
        {
          imgUrl: annualPhysical,
          title: t('benefits.annualPhysical'),
        }
      ]
    },
    {
      title: t('benefits.hiltonPrivilege'),
      showFlag: showHiltonPrivilege.value,
      flag: 'hiltonPrivilege',
      cardList: [

        {
          imgUrl: GOHilton,
          title: t('benefits.GOHilton')
        },
        {
          imgUrl: TME_giftShop,
          title: t('benefits.TME-giftShop')
        },
        {
          imgUrl: otherDiscounts,
          title: t('benefits.otherDiscounts')
        },
        {
          imgUrl: sf,
          title: t('benefits.SF')
        }
      ]
    },
    {
      title: t('benefits.womenHealth'),
      showFlag: showWomenHealth.value,
      flag: 'womenHealth',
      cardList: [
        {
          imgUrl: healthTips,
          title: t('benefits.healthTips')
        },
        {
          imgUrl: mentalCare,
          title: t('benefits.mentalCare')
        },
        {
          imgUrl: womenWellbeing,
          title: t('benefits.womenWellbeing')
        },
      ]
    },
    {
      title: t('benefits.mentalWellbeing'),
      showFlag: showWmentalWellbeing.value,
      flag: 'mentalWellbeing',
      cardList: [
        {
          imgUrl: mentalHealth,
          title: t('benefits.mentalHealth')
        },
        {
          imgUrl: caregivingConcierge,
          title: t('benefits.caregivingConcierge')
        },
        {
          imgUrl: careForAll,
          title: t('benefits.careForAll')
        },
      ]
    },
  ]
})

const changeTabMb = (flag) => {
  if (device.value === 'mb') {
    switch (flag) {
      case 'showPhysicalWellness':
        showPhysicalWellness.value = !showPhysicalWellness.value;
        break;
      case "hiltonPrivilege":
        showHiltonPrivilege.value = !showHiltonPrivilege.value;
        break;
      case "womenHealth":
        showWomenHealth.value = !showWomenHealth.value;
        break;
      case "mentalWellbeing":
        showWmentalWellbeing.value = !showWmentalWellbeing.value;
        break;
    }
  }
}

const imageTrackList = [
  {
    img: track_img1,
    bigImg: track_img1,
  },
  {
    img: track_img2,
    bigImg:
      track_img2,
  },
  {
    img: track_img3,
    bigImg:
      track_img3,
  },
  {
    img: track_img4,
    bigImg:
      track_img4,
  },
  {
    img: track_img5,
    bigImg:
      track_img5,
  },
  {
    img: track_img6,
    bigImg:
      track_img6,
  },
  {
    img: track_img7,
    bigImg:
      track_img7,
  },
];


const activeTrack = ref(0);
const changeActiveTrack = (type) => {
  if (type === 'add') {
    leftActive.value = false
    if (activeTrack.value === 6) {
      activeTrack.value = 0
    } else {
      activeTrack.value++;
    }
  } else {
    leftActive.value = true
    if (activeTrack.value === 0) {
      activeTrack.value = 6
    } else {
      activeTrack.value--;
    }
  }

};

const goSearchJob = () =>{
   router.push({
    path: "/searchJob",
  });
}
</script>

<style lang="scss" scoped>
.header-img {
  z-index: 1;
    justify-content: center;
      padding-top: 30px;
      padding-bottom: 30px;
    
      .hc-hero-secondary__right-img {
        padding: 16px;
        border-radius: 9999px 9999px 0 0;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.2) 100%);
        margin-right: -11px;
      }
}
.has-t-disp-2-font-size {
  width: 84%;
  font-weight: 400;
  font-size: 4rem;
  line-height: 4.5rem;
}

.header_bg {
  background-image: url('/src/assets/image/0309f6767e03a8bbd20a1fc4ca64a2575f675aae.jpeg');
}

.hc-hero-secondary__title{
  font-weight: 400;
}

.hc-cntr {
  padding-bottom: 80px;
}

.hc-tabbed-card__intro-title{
  font-weight: 400;
  margin-bottom: 0px;
}
.hc-tabbed-card__intro-content{
  padding-right: 22px;
  font-size: 1.25rem;
  line-height: 2rem;
}
.padding-bottom {
  padding-bottom: 80px;
}

.hc-tabbed-card__card{
  width: 197px;
  .wp-block-image{
    margin-bottom: 70px;
  }
}

.apply_bg {
  background-image: url('/src/assets/image/benefits/apply-bg-pc.jpg');
}
.apply_bg_mb {
  background-image: url('/src/assets/image/benefits/apply-bg-mb.jpg');
}


.apply-content {
  display: flex;
  align-items: center;

  .apply-content__left {
    flex: 1;
  }

  .apply-content__right {
    width: 466px;
    height: 488px;
    border: 1px solid #fff;
    border-bottom: unset;
    border-radius: 50% 50% 0 0;
    padding: 12px;
    padding-bottom: unset;

    .apply-content__right-in {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 30px;
      padding-bottom: 80px;
      border-radius: 50% 50% 0 0;
      height: 100%;
      background-color: #fff;
      .has-t-disp-3-font-size{
        font-weight: 400;
      }
    }
  }
}
 .hc-img-gal__info {
   .has-md-font-size {
     font-size: 1.25rem;
     line-height: 2rem;
   }
 }
.hc-img-gal__title{
  font-weight: 400;
}
.hc-img-gal__stage{
  margin-right: 10px;
}
       
.under-line{
      padding-bottom: 0px;
      border-bottom: 1px solid #4d5660;
}
.track-img{
  padding-top: 80px;
}
    .hc-hero-secondary__description {
      margin-bottom: 0px;
    }
@media (max-width: 767px) {
    .hc-hero-secondary__breadcrumbs {
        display: none;
      }
  .hc-cntr {
    padding-bottom: 20px;
  }

     .hc-img-gal__info {
       .has-md-font-size {
         font-size: 1rem;
          line-height: 1.571rem;
       }
     }
  .padding-bottom {
    padding-bottom: 32px
  }

  // 手机端清除padding
  .hc_container_mobile_np {
    padding-inline: 0px !important;
  }

     .header_bg {
       background-image: unset;
       background-color: rgba(240, 233, 230, 1);
     }
  
     .hc-hero-secondary__body {
       background: linear-gradient(180deg,
           rgba(240, 233, 230, 1) 0%,
           rgba(240, 233, 230, 0.2) 100%);
     }

  .hc-tabbed-card {
    gap: 0;
  }

  .hc-tabbed-card__intro-content{
    padding-right: unset;
    font-size: 1rem;
      line-height: 1.571rem;
  }

  .hc-tabbed-card__intro {
    gap: 32px;
    .hc-tabbed-card__intro-title {
      font-size: 2.285rem;
        line-height: 2.857rem;
        margin-bottom: 0;
    }
  }
    .has-t-disp-2-font-size {
      width: 100%;
      font-weight: 400;
      font-size: 2.285rem;
      line-height: 2.857rem;
    }


  .hc-tabbed-card__panel-body {
    gap: 0px 8px;
  }

  .hc-tabbed-card__row {
    border-top: unset;

    .hc-tabbed-card__row-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      background-color: rgba(240, 233, 230, 1);
      margin-bottom: 8px;
        .section-line {
            display: block;
            width: 12px;
            height: 12px;
            position: relative;
            transition: transform 0.3s ease;
            $w: 1px;
        
            &::before,
            &::after {
              content: "";
              position: absolute;
              background: #002f61;
              transition: all 0.3s ease;
            }
        
            &::before {
              top: 50%;
              left: 0;
              width: 100%;
              height: $w;
              border-radius: $w;
              transform: translateY(-50%);
            }
        
            &::after {
              top: 0;
              left: 50%;
              width: $w;
              height: 100%;
              border-radius: $w;
              transform: translateX(-50%);
            }
          }
    }

    .hc-tabbed-card__cards {
              height: 0;
              overflow: hidden;
              transition: height 0.4s ease;
    }
    .hc-tabbed-card__card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 20px;
      .wp-block-image {
        margin: unset;
      }
    }
  
  }
  .hc-tabbed-card__row.active{
      .hc-tabbed-card__cards {
          height: 100%;
          overflow: hidden;
        }
        .hc-tabbed-card__row-title{
                .section-line {
                    transform: rotate(180deg);
                
                    &::after {
                      opacity: 0;
                    }
                  }
        }
          
  }

  .track-img {
    background-color: unset;
    padding: 0;

    .hc-img-gal {
      padding-block: 32px;
    }

    .hc-img-gal__info {
      padding: 0 20px;
      padding-bottom: 32px;
    }
        .hc-img-gal__stage{
          margin: unset;
        }
        .mb-hidden{
          display: none;
        }
        .hc-img-gal__controls_mobile{
          margin-top: 16px;
          justify-content: space-between;

          .trans-180{
            transform: rotate(180deg);
          }
        }

    .track-title-mb {
      font-size: 2.285rem;
      line-height: 2.857rem;
      margin-bottom: 0;
    }
  }
    .apply-content{
      flex-direction: column;
      .apply-content__left{
        display: flex;
        justify-content: center;
      }
    .apply-content__right {
        width: 80%;
        height: 292px;
        .apply-content__right-in {
          padding-bottom: 44px;
          .has-t-disp-3-font-size{
            font-size: 2.285rem;
          }
        }
      }
    }
}
</style>
